export const SITE_URL = 'https://jsontoon.in';
export const SITE_NAME = 'JSON to TOON';
export const SITE_TAGLINE = 'Reduce LLM Token Usage by 30-60%';
export const SITE_DESCRIPTION =
  'Free JSON to TOON converter. Optimize your LLM costs with 30-60% token reduction. Works with GPT-4, Claude, Gemini. Fast, private, no signup required.';

export const OG_IMAGE_PATH = '/og-image.png';
export const TWITTER_IMAGE_PATH = '/twitter-image.png';
export const LOGO_PATH = '/favicon-512.png';

// Anchor date for content age. Matches the first SEO-substantive commit
// (3c33f57 — "Add comprehensive SEO optimization and new sections").
export const SITE_PUBLISHED_DATE = '2025-11-10';

export const absoluteUrl = (path: string): string => {
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
};
